<template>
  <div>
    <card
      v-if="with_card_background"
      card-body-classes="table-full-width"
      no-footer-line
    >
      <div>
        <div class="d-flex justify-content-end">
          <n-button
            v-if="create"
            @click.native="handleCreate()"
            class="w-20"
            type="primary"
            >Criar</n-button
          >
        </div>
        <my-table
          :loading="loading"
          :raw_data="table"
          :table_columns="table.columns"
          :with_pagination="with_pagination"
          :with_search_input="with_search_input"
          :actionsProp="actions"
          :filter="filter"
          @getData="handleRead"
          @sendDataProp="sendDataProp"
        >
        </my-table>
        <div
          v-if="!loading && !table.data.length"
          class="d-flex justify-content-center my-5"
        >
          <p>{{ emptyMsg }}</p>
        </div>
      </div>
    </card>
    <div v-else>
      <div>
        <div class="d-flex justify-content-end">
          <n-button
            v-if="create"
            @click.native="handleCreate()"
            class="w-20"
            type="primary"
            >Criar</n-button
          >
        </div>
        <my-table
          :loading="loading"
          :raw_data="table"
          :table_columns="table.columns"
          :with_pagination="with_pagination"
          :with_search_input="with_search_input"
          :actionsProp="actions"
          :filter="filter"
          @getData="handleRead"
          @sendDataProp="sendDataProp"
        >
        </my-table>
        <div
          v-if="!loading && !table.data.length"
          class="d-flex justify-content-center my-5"
        >
          <p>{{ emptyMsg }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * How it works?
 * 1. You can pass the data and loader through the component or pass the route and methods you want: create, read, update, destroy
 * 2. For the dynamic methods, you need to pass the route for vuex module! For example: ${"brands"}/read
 * (needs functions: create, read, update, destroy in actions)
 * (needs list for the getter name of return of read action) For example: $getters[${"brands"}/list]
 * (the read method, use dispatch action and getters to get the data and populate the table)
 * (the create method, just change the route to ${route_name}/create, must have a route for this)
 * (the update method, active a button in the last column of the table, with the route to ${route_name}/edit/${row_id})
 * (the destroy method, active a button in the last column of the table, open a confirmation modal with the route to ${route_name}/destroy/${row_id})
 * */

import Table from "@/components/Table/Table";
import { Loader } from "@/components";
export default {
  props: {
    // Route for dispatch actions
    route: {
      type: String,
      required: false,
    },
    // Show the create button and the redirect route to create
    create: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Dispatch the read action "read" and get the data from the store "list"
    read: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Optional info for read action
    read_form: {
      type: Object,
      default: () => {},
      required: false,
    },
    // Show the update button on the table component and the redirect route to edit
    update: {
      type: Boolean,
      default: false,
      required: false,
    },
    // For the update route, you need to pass the route name to get the id of the row
    update_route_name: {
      type: String,
      required: false,
    },
    // Open a modal to update action, else, redirect to the route
    update_modal: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Id for the optional info
    optional_id: {
      type: Number,
      required: false,
    },
    // Show the destroy button on the table component and the redirect route to destroy on the action
    destroy: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Show the detail button on the table component and the redirect route to detail
    detail: {
      type: Boolean,
      default: false,
      required: false,
    },
    // For the detail route, you need to pass the route name to get the id of the row
    detail_route_name: {
      type: String,
      required: false,
    },
    // If the route to create its not just the current one, you need to pass the pos_route
    pos_route: {
      type: String,
      required: false,
    },
    // The columns of the table, {label: "string", prop: "response_key", minWidth: "number", type: "text/image"}
    columns: {
      type: Array,
      default: () => [],
      required: false,
    },
    // If you want to pass the data to the table, without dispatch the action on read logic, you can though the data prop
    table_data_prop: {
      type: Object,
      required: false,
    },
    // For loading outside the component, you can pass the loading prop
    loadingProp: {
      type: Boolean,
      default: false,
      required: false,
    },
    // The message to show when the table is empty
    emptyMsg: {
      type: String,
      default: "Sem dados",
      required: false,
    },
    // The option of remove the card background
    with_card_background: {
      type: Boolean,
      default: true,
      required: false,
    },
    // The option of pagination for the table
    with_pagination: {
      type: Boolean,
      default: true,
      required: false,
    },
    // The option of search input for the table
    with_search_input: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Forces update of methods
    force_update: {
      required: false,
    },
    // Add a button on the table for changing status order
    action_change_order_status: {
      type: Boolean,
      default: false,
    },
    // Add a button on the table for changing status order
    action_generate_order: {
      type: Boolean,
      default: false,
    },
    // Add a filter option in the top of table
    filter: {
      type: String,
      required: false,
    },
  },
  name: "crudMaker",
  components: {
    "my-table": Table,
    Loader,
  },
  data: () => ({
    tableData: {
      data: [],
      columns: [],
    },
    actions: [
      {
        method: "update",
        route_name: "",
        modal: false,
        optional_id: null,
      },
      {
        method: "destroy",
        route: "",
        optional_id: null,
      },
      {
        method: "detail",
        route_name: "",
      },
      {
        method: "change_order_status",
        active: false,
      },
      {
        method: "generate_order",
        active: false,
      },
    ],
    loading: false,
  }),
  async mounted() {
    if (this.read) await this.handleRead();
    if (this.update) await this.handleUpdate();
    if (this.destroy) await this.handleDestroy();
    if (this.detail) await this.handleDetail();
    if (this.action_change_order_status) await this.handleChangeOrderStatus();
    if (this.action_generate_order) await this.handleGenerateOrder();
  },
  watch: {
    route: async function () {
      if (this.read) await this.handleRead();
      if (this.update) await this.handleUpdate();
      if (this.destroy) await this.handleDestroy();
      if (this.detail) await this.handleDetail();
      if (this.action_change_order_status) await this.handleChangeOrderStatus();
      if (this.action_generate_order) await this.handleGenerateOrder();
    },
    force_update: async function () {
      if (this.read) await this.handleRead();
      if (this.update) await this.handleUpdate();
      if (this.destroy) await this.handleDestroy();
      if (this.detail) await this.handleDetail();
      if (this.action_change_order_status) await this.handleChangeOrderStatus();
      if (this.action_generate_order) await this.handleGenerateOrder();
    },
  },
  methods: {
    async handleCreate() {
      !!this.pos_route
        ? this.$router.push({
            path: this.$route.path + this.pos_route + "/create",
          })
        : this.$router.push({ path: this.$route.path + "/create" });
    },
    async handleRead(params) {
      this.loading = true;
      try {
        await this.$store.dispatch(`${this.route}/read`, {
          ...this.read_form,
          url_filter: params?.url_filter,
          url_params: params?.url_params,
          pagination: params?.pagination,
          with_pagination: this.with_pagination,
        });
        this.tableData.data = this.$store.getters[`${this.route}/list`] ?? [];
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate() {
      this.actions.map((action) => {
        if (action.method === "update") {
          if (this.update_modal) {
            action.modal = true;
            action.route_name = this.update_route_name;
            action.optional_id = this.optional_id;
          } else {
            action.route_name = this.update_route_name;
          }
        }
      });
    },
    async handleDestroy() {
      this.actions.map((action) => {
        if (action.method === "destroy") {
          action.route = this.route;
          action.optional_id = this.optional_id;
        }
      });
    },
    async handleDetail() {
      this.actions.map((action) => {
        if (action.method === "detail") {
          action.route_name = this.detail_route_name;
        }
      });
    },
    async handleChangeOrderStatus() {
      this.actions.map((action) => {
        if (action.method === "change_order_status") {
          action.active = true;
        }
      });
    },
    async handleGenerateOrder() {
      this.actions.map((action) => {
        if (action.method === "generate_order") {
          action.active = true;
        }
      });
    },
    sendDataProp(val) {
      this.$emit("getData", val);
    },
    verifyTableData() {
      // Verifica se o dado é enviado por prop
      if (!!this.table_data_prop) {
        return this.table_data_prop;
      } else {
        // Verifica se o dado é enviado paginado pelo backend
        if (this.tableData?.data?.paginate) {
          this.tableData.data.columns = this.columns;
          return this.tableData.data;
        } else {
          this.tableData.columns = this.columns;
          return this.tableData;
        }
      }
    },
  },
  computed: {
    table() {
      return this.verifyTableData();
    },
  },
};
</script>

<style scoped>
.btn-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.empty-msg {
  font-size: 1.5em;
  font-weight: 500;
  color: #999;
}
</style>
